// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"4538":"10b02c65","6148":"69b2bcf5"}[chunkId] || chunkId) + "." + {"1739":"9a0708e33b0bac57","2524":"53fb72971cd97e6f","4538":"f83fcf39122d1f16","4848":"46514b21da67d4ad","5029":"fe4ba5541dcb5133","6148":"068ddb3a0e1dbf18","8860":"e7c88903efc48671"}[chunkId] + ".js";
};